{
  const storageKey = 'bfr-nominate-email';

  document.querySelectorAll('[data-bfr-nominate-email]').forEach((input) => {
    input.form.addEventListener('submit', () => {
      try {
        sessionStorage.setItem(storageKey, input.value);
      } catch (error) {}
    });
  });

  document.querySelectorAll('[data-bfr-newsletter-email]').forEach((input) => {
    if (input.value) return;
    try {
      input.value = sessionStorage.getItem(storageKey) || '';
    } catch (error) {}
  });
}
